import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getForumGroupFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/getforumgroups";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getAllForumFromServerWithFileID = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/getallforumswithfileid";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const sendCommentToServer = async (newData, file, controller) => {
  try {
    const datas = new FormData();
    datas.append("file", file);
    datas.append("data", JSON.stringify(newData));
    let url = config.apiserver + "/forum/storecomment";
    Axios.defaults.timeout = 5500;
    let result = await Axios.post(url, datas, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const selectForum = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/selectforum";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const deleteForum = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/deleteforum";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const updateComment = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/updatecomment";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const setTopicVisible = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/settopicvisible";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
export const getTopicsFromServer = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/gettopics";
    let result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });

    return result.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};

export const getSelectedCommentsWithFileid = async (newData, controller) => {
  try {
    let url = config.apiserver + "/forum/getselectedcommentswithfileid/";

    let response = await Axios.post(url, newData, {
      headers: {
        "x-access-token": controller.token,
      },
    });
    return response.data;
  } catch (err) {
    return returnError(err, "fa");
  }
};
